import { render, staticRenderFns } from "./StockRecallView.vue?vue&type=template&id=67d7d12b"
import script from "./StockRecallView.vue?vue&type=script&lang=js"
export * from "./StockRecallView.vue?vue&type=script&lang=js"
import style0 from "./StockRecallView.vue?vue&type=style&index=0&id=67d7d12b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports